import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { CMDSpThaihiloStatistics, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { hostsSliceActions } from '../../../modules/host/slice';
import { ThaiHiLoStatistics } from '@/models/games/thaiHiLo';

export class CMDSpThaiHiLoStatisticsHandler extends AbstractHandler {
    _command: CMDSpThaihiloStatistics;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpThaihiloStatistics;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const statistics = {} as ThaiHiLoStatistics;
        const hostId = this._command.HostID;
        const val = this._command.Statistics;
        const totalNum: number =
            val.Number1Count +
            val.Number2Count +
            val.Number3Count +
            val.Number4Count +
            val.Number5Count +
            val.Number6Count;
        statistics.Dice1Rate = val.Number1Count / totalNum;
        statistics.Dice2Rate = val.Number2Count / totalNum;
        statistics.Dice3Rate = val.Number3Count / totalNum;
        statistics.Dice4Rate = val.Number4Count / totalNum;
        statistics.Dice5Rate = val.Number5Count / totalNum;
        statistics.Dice6Rate = val.Number6Count / totalNum;

        statistics.HiCount = val.HiCount;
        statistics.LoCount = val.LoCount;
        statistics.ElevenHiLoCount = val.ElevenHiLoCount;

        const total = val.HiCount + val.LoCount + val.ElevenHiLoCount;
        statistics.HiRate = val.HiCount / total;
        statistics.LoRate = val.LoCount / total;
        statistics.ElevenHiLoRate = val.ElevenHiLoCount / total;        

        dispatch(hostsSliceActions.updateStatistic({ hostId, statistics }));
    }
}
